const init = () => {

	for (const el of document.querySelectorAll('[data-number-picker]')) {

		const lowest  = el.getAttribute('data-number-picker-lowest')
		const highest = el.getAttribute('data-number-picker-highest')
		const step    = parseInt(el.getAttribute('data-number-picker-step'))
		const fld     = el.querySelector('[data-number-picker-field]')
		const numEl   = el.querySelector('[data-number-picker-number]')
		const decBtn  = el.querySelector('[data-number-picker-decrease]')
		const incBtn  = el.querySelector('[data-number-picker-increase]')
		const arrBtns = [decBtn, incBtn]

		el.addEventListener('number-picker-btn-clicked', (e) => {

			// Get current field value
			let val = parseInt(fld.value);

			// Increase/decrease value by step amount
			switch (e.detail) {

				case '+':
					val += step;
					break;
				
				case '-':
					val -= step;
			}

			fld.value       = val // Set field value to new amount
			numEl.innerHTML = val // Display new amount on number picker

			// Check if btns need to be disabled
			if (lowest !== null && (val <= parseInt(lowest))) {
				decBtn.disabled = true
			} else {
				decBtn.disabled = false
			}

			if (highest !== null && (val >= parseInt(highest))) {
				incBtn.disabled = true
			} else {
				incBtn.disabled = false
			}

			// Dispatch event
			const ev = new Event('number-picker-changed', {
				bubbles: true
			})
			el.dispatchEvent(ev);
		})

		// Add event listeners for increase/decrease btns
		for (const btn of arrBtns) {

			btn.addEventListener('click', (e) => {

				const dir = (btn.hasAttribute('data-number-picker-decrease')) ? '-' : '+'

				const ev = new CustomEvent('number-picker-btn-clicked', {
					bubbles: true,
					detail: dir
				})
				btn.dispatchEvent(ev);
			})

		}
	}

}

export default function() {
    init();
}